import { SVGProps, Ref, forwardRef } from 'react';

export const MicCrossedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m15.5 14.5-1 .995-3.29-3.29c-.767.386-1.63.596-2.512.666V14.1h2.596v1.4H4.629v-1.4h2.669v-1.229c-2.543-.203-4.919-1.559-5.303-4.971h1.41c.179 1.3.706 2.1 1.32 2.607.806.665 1.964.992 3.273.992.785 0 1.517-.118 2.15-.356l-.84-.84a4.2 4.2 0 0 1-1.31.197c-1.666 0-3.333-.833-3.333-3.332V5.66L.5 1.495 1.5.5z"
                    fill="currentColor"
                />
                <path
                    d="M13.267 10.272c.37-.647.627-1.432.733-2.372h-1.41a4.9 4.9 0 0 1-.364 1.331z"
                    fill="currentColor"
                />
                <path
                    d="M11.33 7.168q-.001.584-.115 1.052L5.049 2.054C5.637.92 6.817.503 7.998.503c1.666 0 3.332.833 3.332 3.332z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MicCrossedFilledSize16Glyph.displayName = 'MicCrossedFilledSize16Glyph';
